import { type FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { type Menus } from 'src/routers/menu';
import styles from './menu-list.module.scss';
// import menuActiveIcon from '@assets/images/header/menu-active.svg';

interface OwnProps {
  menu: Menus;
}

const MenuList: FC<OwnProps> = ({ menu }) => {
  const location = useLocation();
  const isActive = location.pathname.indexOf(menu.path) === 0;

  return (
    <div className={styles.menu_a}>
      <Link
        to={menu.path}
        className={isActive ? styles.active_menu : ''}
        target={menu.target || '_self'}
      >
        <span>{menu.name}</span>
        {/* {isActive ? <img src={menuActiveIcon} /> : null} */}
      </Link>
    </div>
  );
};

export default MenuList;
